module.exports = __webpack_public_path__ + "static/media/option4.b042b370.png";